// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"VideoPlayer_videoContainer__CUHla","videoPlayer":"VideoPlayer_videoPlayer__gy_TZ","playButton":"VideoPlayer_playButton__WuUBq"};